import { Outlet } from "react-router-dom";
import { PublicHeader, PublicFooter } from "./Layout";

export default function PublicLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-[#0A0A0A]">
      <PublicHeader />
      <main className="flex-1">
        <Outlet />
      </main>
      <PublicFooter />
    </div>
  );
}
